<template>
  <el-dialog
    title="提交送样单"
    :visible.sync="myOpen"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form :model="form" :rules="rules" ref="form" label-position="top">
      <el-form-item label="合同号：" prop="contractNo">
        <el-input
          v-model="form.contractNo"
          placeholder="请选择合同号"
          clearable
          class="contract-input"
          style="width: 400px"
          readonly
          @click.native="openContractSelect"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="快递单号：" prop="trackingNumber">
        <el-input
          v-model="form.trackingNumber"
          placeholder="请输入快递单号"
          style="width: 400px"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="送样单文件（仅支持EXCEL文件，大小不超过10mb）："
        prop="fileUrl"
      >
        <el-upload
          ref="upload"
          :file-list="fileList"
          :limit="1"
          :on-exceed="handleExceed"
          :before-upload="beforeUpload"
          :on-change="(file, fileList) => (this.fileList = fileList)"
          :on-success="(response, file, fileList) => updateFile(file, fileList)"
          :on-remove="(file, fileList) => updateFile(file, fileList)"
          :headers="uploadHeaders"
          :data="uploadData"
          :action="uploadAction"
          :accept="uploadAccept"
        >
          <el-button type="primary">选择文件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit" style="margin-right: 10px"
        >确 定</el-button
      >
      <el-button @click="handleClose">取 消</el-button>
    </div>

    <el-dialog
      width="80%"
      title="订单列表"
      :visible.sync="innerVisible"
      append-to-body
      @close="onInnerClose"
    >
      <div class="queryForm">
        <el-form :inline="true" class="demo-form-inline" :model="queryForm">
          <el-form-item>
            <el-input
              v-model="queryForm.bpOrderNo"
              placeholder="订单号"
              size="medium"
              clearable
              class="input-style"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="queryForm.contractNo"
              placeholder="合同号"
              size="medium"
              clearable
              class="input-style"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="handleSearch"
              >搜索</el-button
            >
            <el-button
              @click="handleReset"
              size="medium"
              style="margin-left: 10px"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="{
            'background-color': '#fafafa',
            color: '#000000',
            'font-weight': 400,
          }"
          stripe
          class="elTable"
        >
          <el-table-column label="选择" width="55" align="center">
            <template slot-scope="scope">
              <el-checkbox
                :value="
                  selectedRow &&
                  selectedRow.milestoneno === scope.row.milestoneno"
                @change="(val) => onRowCheck(val, scope.row)"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="milestoneno"
            label="订单号"
            min-width="20%"
          ></el-table-column>
          <el-table-column
            prop="pk_busicontract"
            label="合同号"
            min-width="20%"
          ></el-table-column>
          <el-table-column
            prop="ismilestone"
            label="里程碑"
            min-width="20%"
          ></el-table-column>
        </el-table>
      </div>
      <div class="elPagination" v-if="total > 0">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page-sizes="pageSizes"
          :page-size="queryForm.pageSize"
          :total="total"
        >
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="confirmSelect"
          style="margin-right: 10px"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </el-dialog>
</template>


<script>
import { saveSampleList } from "@/api/sampleList/sampleList";
import { getBsgLtcOrderList } from "@/api/order/index";
import { getUploadPath } from "@/api/file/index";

export default {
  name: "saveSampleList",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      myOpen: this.value, //是否展示弹窗
      innerVisible: false, // 内层弹窗
      form: {
        contractNo: "", // 合同号
        trackingNumber: "", // 快递单号
        fileUrl: "", // 文件URL
        orderNo: "", // 订单号
        lcb: "", // 里程碑
        fileName: "", // 文件原名
        id: null,
        limsId: "", // limsId
      },
      tableData: [],
      selectedRow: null,
      total: 0,
      queryForm: {
        contractNo: "", // 合同号
        bpOrderNo: "", // 订单号
        pageNum: 1,
        pageSize: 12,
      },
      pageSizes: [12, 24, 36],

      rules: {
        contractNo: [
          { required: true, message: "请选择合同号", trigger: "blur" },
        ],
        trackingNumber: [
          { required: true, message: "请输入快递单号", trigger: "blur" },
        ],
        fileUrl: [{ required: true, message: "请上传文件", trigger: "blur" }],
      },

      //上传文件请求头
      uploadHeaders: {
        Authorization: this.$utils.storage.get("user").token,
      },
      //上传参数
      uploadData: {
        type: 0,
      },
      //上传路径
      uploadAction: "",
      uploadAccept: ".xls,.xlsx", //上传格式
      fileList: [],
    };
  },

  watch: {
    value: {
      handler(newVal) {
        this.myOpen = newVal;
        if (!newVal) return;
        this.$nextTick(() => {
          if (this.rowData) {
            // 编辑：回填整行
            Object.assign(this.form, {
              id: this.rowData.id, // 带上 id
              contractNo: this.rowData.contractNo,
              trackingNumber: this.rowData.trackingNumber,
              fileUrl: this.rowData.fileUrl,
              orderNo: this.rowData.orderNo,
              lcb: this.rowData.lcb,
              fileName: this.rowData.fileName,
              limsId: this.rowData.limsId,
            });
            // 回显已上传文件到 el-upload
            this.fileList = this.rowData.fileUrl
              ? [
                  {
                    name: this.rowData.fileName,
                    url: this.rowData.fileUrl,
                  },
                ]
              : [];
          } else {
            // 新建：显式清空，避免沿用上一次编辑残留
            this.form.id = null;
            this.form.contractNo = "";
            this.form.trackingNumber = "";
            this.form.fileUrl = "";
            this.form.orderNo = "";
            this.form.lcb = "";
            this.form.fileName = "";
            this.form.limsId = "";
            this.fileList = [];
          }
          this.$refs.form.clearValidate();
        });

      },
    },
  },

  created() {
    this.handleGetUploadPath();
  },

  methods: {
    handleFileChange(file, fileList) {
      // 把选中的文件写进表单（这里存文件名；要真实文件对象用 file.raw）
      this.form.fileUrl = file.name;
      this.$refs.form.clearValidate("fileUrl"); // 清掉"请上传文件"提示
    },

    handleExceed() {
      this.$message.warning("只能上传一个文件，请先删除已选文件");
    },

    beforeUpload(file) {
      const isExcel =
        /\.(xls|xlsx)$/i.test(file.name) ||
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isExcel) {
        this.$message.error("只能上传 Excel 文件（.xls / .xlsx）");
        return false; // 返回 false 阻止本次上传
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("文件大小不能超过 10MB");
        return false;
      }
      return true;
    },

    // 获取上传图片接口地址
    handleGetUploadPath() {
      getUploadPath(this.uploadData).then((data) => {
        this.uploadAction = data;
      });
    },

    // 图片上传成功回调
    updateFile(file, fileList) {
      const item = fileList.find(
        (it) => it.response && it.response.data
      );
      if (item) {
        this.form.fileUrl = item.response.data;
        this.form.fileName = item.name;
        this.$refs.form.clearValidate("fileUrl"); // 清掉"请上传文件"
      } else {
        this.form.fileUrl = ""; // 删除文件时清空
      }
    },

    // 改变页数
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.handleGetOrderLsit();
    },

    // 搜索
    handleSearch() {
      this.queryForm.pageNum = 1;
      this.handleGetOrderLsit();
    },

    // 重置
    handleReset() {
      this.queryForm.contractNo = "";
      this.queryForm.bpOrderNo = "";
      this.queryForm.pageNum = 1;
      this.handleGetOrderLsit();
    },

    // 改变每页数量
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.handleGetOrderLsit();
    },

    onInnerClose() {
      this.selectedRow = null;
    },
    onRowCheck(checked, row) {
      if (checked) {
        this.selectedRow = row;
      } else if (
        this.selectedRow &&
        this.selectedRow.milestoneno === row.milestoneno
      ) {
        this.selectedRow = null;
      }
    },

    confirmSelect() {
      if (!this.selectedRow) {
        this.$message.warning("请先选择一行订单");
        return;
      }
      // 把选中行的数据回填到主表单
      this.form.orderNo = this.selectedRow.milestoneno; // 订单号
      this.form.contractNo = this.selectedRow.pk_busicontract; // 合同号
      this.form.lcb = this.selectedRow.ismilestone; // 里程碑
      this.selectedRow = null;
      this.$refs.form.clearValidate("contractNo");
      this.innerVisible = false;
    },
    openContractSelect() {
      this.$refs.form.clearValidate("contractNo");
      this.innerVisible = true;
      this.handleGetOrderLsit();
    },
    async handleGetOrderLsit() {
      const params = {
        pageNum: this.queryForm.pageNum,
        pageSize: this.queryForm.pageSize,
        bpOrderNo: this.queryForm.bpOrderNo,
        contractNo: this.queryForm.contractNo,
        type: 22,
      };
      const params2 = this.$utils.map.getNotEmptyObj(params);
      const orderData = await getBsgLtcOrderList(params2);
      //获取table数据
      this.tableData = JSON.parse(JSON.stringify(orderData.orderList));
      this.total = orderData.totalNum;
    },

    handleClose() {
      this.selectedRow = null;
      // 重置form表单
      this.$refs.form.resetFields();
      // 清空 el-upload 内部已显示的文件列表
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      this.myOpen = false;
      this.$emit("input", this.myOpen);
    },

    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return; // 校验不通过，拦截提交
        saveSampleList(this.form).then((res) => {
          this.$message.success("保存成功");
          this.$refs.form.resetFields();
          this.myOpen = false;
          this.$emit("refresh");
          this.$emit("input", false);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  width: 640px !important;
}

::v-deep .el-dialog__body {
  height: 400px;
  overflow-y: auto;
  padding: 20px;
}

::v-deep .el-form-item {
  margin-bottom: 25px;
}

::v-deep .el-form-item__label {
  line-height: 32px;
  padding-bottom: 4px;
}

::v-deep .contract-input .el-input__inner {
  cursor: pointer;
}

::v-deep .el-upload-list__item{
  width:300px;
}

/* 与订单页 queryForm 组件保持一致的横向排列与高度 */
.queryForm {
  margin-bottom: 15px;

  .demo-form-inline {
    @include start;
    display: flex;
    flex-direction: row;

    .el-form-item {
      margin-bottom: 0;
      .el-form-item__content {
        display: flex;
        align-items: center;
        line-height: 36px;
      }

      .el-input {
        display: inline-flex;
      }
    }
  }

  .input-style {
    width: 200px;
  }
}

.elPagination {
  @include end;
  padding: 25px;
  background: #ffffff;
}
</style>